module.exports = __webpack_public_path__ + "static/media/y-bg.d214fc64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y-bg.svg
// module id = 457
// module chunks = 0